var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackspace = function SvgIconBackspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.707 9.043a1 1 0 0 1 0 1.414L14.164 12l1.543 1.543a1 1 0 0 1-1.414 1.414l-1.543-1.543-1.543 1.543a1 1 0 0 1-1.414-1.414L11.336 12l-1.543-1.543a1 1 0 0 1 1.414-1.414l1.543 1.543 1.543-1.543a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.42 3.5h13.83A1.75 1.75 0 0 1 22 5.25v13.5a1.75 1.75 0 0 1-1.75 1.75H6.42a1.74 1.74 0 0 1-1.495-.854L.643 12.515a1 1 0 0 1 0-1.03l4.282-7.13A1.74 1.74 0 0 1 6.42 3.5m-.636 15.634.638-.374v-.009zm.64-.383-.001.008.224-.131-.005-.008zm.146-.251H20v-13H6.57L2.666 12z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBackspace;